/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import styled from 'styled-components';
import { BreakPoint } from '../../../../asset/styles';
// import FreeHr from './free/FreeHr';

const StyledField = styled.div`
  margin-top: 24px;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 16px;

  &:first-child {
    margin-top: 16px;
  }

  @media (min-width: ${BreakPoint.desktop}) {
    /*margin-top: 12px;

    &:first-child {
      margin-top: 10px;
    }*/
    margin: 12px 0;
    padding-bottom: 0;
  }
`;

/**
 * {@link Inquiry} free comment 親コンポーネント
 * @param {*} props React.props
 * @return {*} React.node - {@link Inquiry} free comment 親コンポーネント
 * @constructor
 */
const BodyFree = props => (
  <StyledField className={'BodyFree'}>{props.children}</StyledField>
);

export default BodyFree;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/inquiry/node/body/BodyFree.js